import mutationsTypes from '@/store/mutationTypes'
import axios from 'axios'
import api from '@/config/api'
import apiMock from '@/config/apiMock'
import { commonUtil } from '@/util'
import getCsrfToken from '@/store/Csrf'

const Actions = {
  // ENO01 お知らせ一覧取得
  getNoticeListFromApi: async (
    { state, dispatch, commit, getters, rootGetters, rootState },
    params
  ) => {
    return await axios
      // .get(apiMock.NOTICE_LIST)
      .get(api.NOTICE_LIST)
      .then((response) => {
        const path = mutationsTypes.NOTICE_SET_NOTICE_LIST
        commit(path, response.data.data)
        const getData = getters.getNoticeListFromState
        const ret = commonUtil.afterApiSuccessProcess(response, getData)
        return ret
      })
      .catch((error) => {
        // commonErrorControl(error.response)
        commonUtil.afterApiFailProcess(error.response)
        return false
      })
  }
}

export default Actions
